import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { isAdminRoute } from './Router';

// The admin panel runs as its own page (opened in a new tab) so it can be
// bookmarked, refreshed safely, and kept open alongside the game.
const Root = isAdminRoute()
	? React.lazy(() => import('./Components/AdminPanel/AdminApp'))
	: React.lazy(() => import('./Components/App'));

const entry = (
	<React.Suspense fallback={<div className="app-loading">Loading…</div>}>
		<Root />
	</React.Suspense>
);

ReactDOM.render(entry, document.getElementById('root'));

// This CRA build does not generate a service worker. Unregister any worker
// left by an older deployment instead of requesting a nonexistent script.
import('./serviceWorker').then((sw) => sw.unregister());